(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-id/assets/javascripts/use-cart-callback.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-id/assets/javascripts/use-cart-callback.js');
"use strict";

var _svs$core$config$data, _svs$core$config$data2;
const _React = React,
  useEffect = _React.useEffect;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const COUPON_VALID = svs.components.tipsen.engine.constants.couponStatus.COUPON_VALID;
const _svs$components$tipse = svs.components.tipsen.engine.selectors.couponSelectors,
  selectCouponEmpty = _svs$components$tipse.selectCouponEmpty,
  selectCouponStatus = _svs$components$tipse.selectCouponStatus;
const selfserviceCart = svs.components.selfserviceCart;
const isSelfService = (_svs$core$config$data = (_svs$core$config$data2 = svs.core.config.data.svsconfig) === null || _svs$core$config$data2 === void 0 ? void 0 : _svs$core$config$data2.isSelfService) !== null && _svs$core$config$data !== void 0 ? _svs$core$config$data : false;
const calculateCartState = (isEmpty, status) => {
  const _selfserviceCart$cons = selfserviceCart === null || selfserviceCart === void 0 ? void 0 : selfserviceCart.constants,
    GAMECALLBACK_HASCOMPLETEGAME = _selfserviceCart$cons.GAMECALLBACK_HASCOMPLETEGAME,
    GAMECALLBACK_HASINCOMPLETEGAME = _selfserviceCart$cons.GAMECALLBACK_HASINCOMPLETEGAME,
    GAMECALLBACK_NOGAME = _selfserviceCart$cons.GAMECALLBACK_NOGAME;
  if (isSelfService) {
    if (isEmpty) {
      return GAMECALLBACK_NOGAME;
    } else if (status === COUPON_VALID) {
      return GAMECALLBACK_HASCOMPLETEGAME;
    }
    return GAMECALLBACK_HASINCOMPLETEGAME;
  }
  return undefined;
};
const useCartCallback = couponId => {
  const isCouponEmpty = useSelector(state => selectCouponEmpty(state, couponId));
  const couponStatus = useSelector(state => selectCouponStatus(state, couponId));
  const getCartInstance = selfserviceCart === null || selfserviceCart === void 0 ? void 0 : selfserviceCart.getCartInstance;
  useEffect(() => {
    if (isSelfService && getCartInstance) {
      getCartInstance().setGameCallback(() => calculateCartState(isCouponEmpty, couponStatus));
    }
  }, [isCouponEmpty, couponStatus, getCartInstance]);
};
setGlobal('svs.components.tipsen.couponId.useCartCallback', useCartCallback);

 })(window);